import { formatShortDate, formatTimestring } from "@app/lib/utils/timestamps";
import {
  differenceInCalendarDays,
  format,
  isToday,
  isYesterday,
} from "date-fns";

export function formatActivityDate(at: number): string {
  if (isToday(at)) {
    return formatTimestring(at);
  }
  if (isYesterday(at)) {
    return "Yesterday";
  }
  return differenceInCalendarDays(Date.now(), at) < 7
    ? format(at, "EEEE")
    : formatShortDate(at);
}
